import { API } from "@/lib/api";

const ORIGIN = API.replace(/\/api$/, "");

export function initials(name) {
  const parts = (name || "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  return (parts[0][0] + (parts.length > 1 ? parts[parts.length - 1][0] : "")).toUpperCase();
}

export function photoSrc(url) {
  if (!url) return null;
  return url.startsWith("/") ? `${ORIGIN}${url}` : url;
}

export function Avatar({ src, name, size = 40, className = "", testId }) {
  const style = { width: size, height: size, fontSize: Math.max(10, Math.round(size * 0.38)) };
  const url = photoSrc(src);
  if (url) {
    return <img data-testid={testId} src={url} alt={name || ""} style={style} className={`rounded-full object-cover shrink-0 bg-zinc-100 ${className}`} />;
  }
  return (
    <div data-testid={testId} data-fallback="initials" style={style} className={`rounded-full bg-gradient-to-br from-red-600 to-black text-white flex items-center justify-center font-bold shrink-0 ${className}`}>
      {initials(name)}
    </div>
  );
}
